import { Component } from '@angular/core';
import { ControlWidget } from '../models/control-widget.directive';

@Component({
	standalone: false,
	selector: 'cs-list-fields-form-widget',
	template: `
		<div class="form-group">
			<cs-list-fields-form
				[formControl]="control"
				[columnVisibility]="nestedVisibility">
			</cs-list-fields-form>
			<div class="pm-form-element-invalid-feedback" *ngIf="errorMessages?.length > 0">
				<small class="{{error.type}}" *ngFor="let error of errorMessages">{{ error.errorMessage }}</small>
			</div>
		</div>
	`
})
export class ListFieldsFormWidgetComponent<T> extends ControlWidget<T> {
	static hasReadOnlyState = true;
	
	/**
	 * Get nested visibility from widgetInfo
	 */
	override get nestedVisibility(): Map<string, boolean> | undefined {
		return this.widgetInfo?.nestedVisibility;
	}
}
